import { Modal } from 'antd';
import React from 'react';
type Props = {
	title: React.ReactNode;
	children?: React.ReactNode;
};

const ModalAlert = ({ children, title }: Props) => {
	return Modal.warning({
		width: '520px',
		keyboard: false,
		maskClosable: false,
		content: children,
		title,
		okText: _('Ok'),
		okButtonProps: { id: 'timeZonesInUsedByOkButton' },
		icon: undefined,
	});
};

export { ModalAlert };
